
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import WebsiteRepositoryInterface, { Website } from "@/services/Website/interfaces";
import { DatabaseInterface, DatabaseRepositoryInterface } from "@/services/Database/interfaces";
import { ServerInterface } from "@/services/Server/Interfaces";

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'websiteRepository',
    'databaseRepository',
    'serverRepository',
  ],
})
export default class DatabaseSelectionDialog extends Vue {
  private websites: Website[] = [];
  private databases: DatabaseInterface[] = [];
  private servers: ServerInterface[] = [];
  private _websiteSearch: string = '';
  private _selectedWebsite?: number;
  private websiteRepository!: WebsiteRepositoryInterface;
  private databaseRepository!: DatabaseRepositoryInterface;
  private databaseRules: [] = [
    (v: number) => !!v || 'Database id is required',
    (v: number) => v > 0 || 'Database id must be greater than 0',
  ];
  public isValid: boolean = true;
  public visible: boolean = true;
  private selectedDatabaseIdentifier?: number
  @Prop() public data: {

    owner?: string,
  };

  set selectedDatabaseId(id: number) {
    this.selectedDatabaseIdentifier = id;
  }

  get selectedDatabaseId(): number {
    return this.selectedDatabaseIdentifier;
  }

  get selectedWebsite(): number {
    return this._selectedWebsite;
  }

  set selectedWebsite(value?: number) {
    this._selectedWebsite = value;
    this.databaseRepository.getDatabases(undefined, undefined, [this._selectedWebsite]).then(value => {
      (this.databases = value[0]);
    });
  }

  public get websiteSearch(): string {
    return this._websiteSearch;
  }

  public set websiteSearch(val: string) {
    if (val && val.length < 3) {
      return;
    }
    this.websiteRepository.searchWebsites(undefined, val, this.data.owner).then((websites) => {
      this.websites = websites.Websites;
    }).catch((err) => {
      this.$errorDialog.show(err.message);
    });
  }

  public async created(): Promise<void> {
    try {
      this.servers = await this.serverRepository.getAllServers();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

  private getServerName(serverId: string): string {
    const server = this.servers.find((s) => s._id === serverId);
    if (!server) {
      return '';
    }

    return server.hostname;
  }

  public saveChanges(): void {
    const currentSelection = this.databases.filter(value => value.id == this.selectedDatabaseIdentifier).pop();
    this.$emit('add', JSON.stringify(currentSelection));
    this.$emit('close');
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
